import axios from "axios";

export function apiGetEmissions(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/videos" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetEmission(instance, id) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/videos/" + id, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveEmission(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/videos", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateEmission(idEmission, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/videos/" + idEmission, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateEmissions(formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/videos/multiple", formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteEmission(idEmission) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/videos/" + idEmission)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
